module.exports = __webpack_public_path__ + "static/media/map-screenshot.ea66f3e8.png";